import { ApiClientImplementation } from 'infra/api-client/api-client'

import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { ApiRepository } from 'repository/api-repository'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'
import { RemoteLoadSurgicalOrderDocument } from 'service/usecases/load-surgical-order-document/load-upload-surgical-order-document'
import SurgicalOrderService from 'presentation/contexts/services/surgical-order-service'
import { RemoteUploadSurgicalOrderDocument } from 'service/usecases/upload-surgical-order-document/remote-upload-surgical-order-document'
import { RemoteLoadSurgicalOrder } from 'service/usecases/load-surgical-order/remote-load-surgical-order'
import { RemoteLoadCid } from 'service/usecases/load-cid/remote-load-cid'
import { RemoteConcludeSurgicalOrder } from 'service/usecases/conclude-surgical-order/remote-conclude-surgical-order'

import { RemoteDeleteSurgicalOrderSolicitation } from 'service/usecases/delete-surgical-order-solicitation/remote-delete-surgical-order-solicitation'
import { RemoteUploadSurgicalOrderDocumentsSameType } from 'service/usecases/upload-surgical-order-documents-same-type/remote-upload-surgical-order-documents-same-type'
import { RemoteLoadFavoriteSurgicalOrders } from 'service/usecases/load-favorite-surgical-orders/remote-load-favorite-surgical-orders'
import { RemoteDeleteFavoritedSurgicalOrder } from 'service/usecases/delete-favorited-surgical-order/remote-delete-favorited-surgical-order'
import { RemoteCheckinSurgicalOrder } from 'service/usecases/checkin-surgical-order/remote-checkin-surgical-order'
import { RemoteLoadFavoriteDoctorSurgicalOrders } from 'service/usecases/load-favorite-doctor-orders/remote-load-favorite-doctor-orders'
import { RemoteUploadToMergeDocument } from 'service/usecases/upload-to-merge-document/remote-upload-to-merge-document'
import { RemoteConfirmMergeDocuments } from 'service/usecases/confirm-merge-documents/remote-confirm-merge-documents'
import { RemoteDeleteUploadedDocuments } from 'service/usecases/delete-uploaded-document-surgical-order/remote-delete-uploaded-document-surgical-order'
import { RemoteCreateSurgicalComment } from 'service/usecases/create-surgical-comment/remote-create-surgical-comment'
import { RemoteGetAgendaAllocation } from 'service/usecases/get-agenda-allocation/remote-get-agenda-allocation'
import { RemoteGetAgendaClassification } from 'service/usecases/get-agenda-classification/remote-get-agenda-classification'
import { RemoteGetAllStatus } from 'service/usecases/get-all-status/remote-get-all-status'
import { RemoteFindAllOpmes } from 'service/usecases/find-all-opmes/remote-find-all-opmes'

export default function makeSurgicalOrderService() {
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(new ApiClientImplementation())
  )

  const surgicalOrderRepository = new SurgicalOrderRepository(apiRepository)

  const loadSurgicalOrderDocument = new RemoteLoadSurgicalOrderDocument(
    surgicalOrderRepository
  )
  const uploadSurgicalOrderDocument = new RemoteUploadSurgicalOrderDocument(
    surgicalOrderRepository
  )
  const loadSurgicalOrder = new RemoteLoadSurgicalOrder(surgicalOrderRepository)
  const loadCids = new RemoteLoadCid(surgicalOrderRepository)
  const concludeSurgicalOrder = new RemoteConcludeSurgicalOrder(
    surgicalOrderRepository
  )
  const deleteSurgicalOrderSolicitation =
    new RemoteDeleteSurgicalOrderSolicitation(surgicalOrderRepository)
  const checkin = new RemoteCheckinSurgicalOrder(surgicalOrderRepository)

  const uploadSurgicalOrderDocumentsSameType =
    new RemoteUploadSurgicalOrderDocumentsSameType(surgicalOrderRepository)

  const loadFavoriteSurgicalOrders = new RemoteLoadFavoriteSurgicalOrders(
    surgicalOrderRepository
  )

  const loadFavoriteDoctorSurgicalOrders =
    new RemoteLoadFavoriteDoctorSurgicalOrders(surgicalOrderRepository)

  const deleteFavoritedSurgicalOrder = new RemoteDeleteFavoritedSurgicalOrder(
    surgicalOrderRepository
  )

  const uploadToMergeDocument = new RemoteUploadToMergeDocument(
    surgicalOrderRepository
  )

  const confirmMergeDocuments = new RemoteConfirmMergeDocuments(
    surgicalOrderRepository
  )

  const deleteUploadedDocuments = new RemoteDeleteUploadedDocuments(
    surgicalOrderRepository
  )

  const createComment = new RemoteCreateSurgicalComment(surgicalOrderRepository)

  const getAgendaAllocation = new RemoteGetAgendaAllocation(
    surgicalOrderRepository
  )
  const getAgendaClassification = new RemoteGetAgendaClassification(
    surgicalOrderRepository
  )

  const getAllStatus = new RemoteGetAllStatus(surgicalOrderRepository)
  const findAllOpmes = new RemoteFindAllOpmes(surgicalOrderRepository)

  return new SurgicalOrderService({
    loadSurgicalOrderDocument,
    uploadSurgicalOrderDocument,
    loadSurgicalOrder,
    loadCids,
    concludeSurgicalOrder,
    deleteSurgicalOrderSolicitation,
    uploadSurgicalOrderDocumentsSameType,
    loadFavoriteSurgicalOrders,
    loadFavoriteDoctorSurgicalOrders,
    deleteFavoritedSurgicalOrder,
    checkin,
    uploadToMergeDocument,
    confirmMergeDocuments,
    deleteUploadedDocuments,
    createComment,
    getAgendaAllocation,
    getAgendaClassification,
    getAllStatus,
    findAllOpmes
  })
}
